import markConversationsAsReadBasedOnConversationIds from '../helpers/markConversationsAsReadBasedOnConversationIds';
import markItemsAsReadBasedOnItemIds from '../helpers/markItemsAsReadBasedOnItemIds';
import * as suppressedItemIdsMapOperations from '../helpers/suppressedItemIdsMapOperations';
import { getRowKeysFromRowIds, getViewFilterForTable } from 'owa-mail-list-store';
import getTableConversationRelation from 'owa-mail-list-store/lib/utils/getTableConversationRelation';
import mailStore from 'owa-mail-store/lib/store/Store';
import { action, select } from 'satcheljs/lib/legacy';
/**
 * Try to perform auto mark as read action
 * @param conversationId the conversationId to be marked as read
 * @param tableView the table view
 * @param state the AutoMarkConversationAsReadState which contains the items
 */
export default action('autoMarkConversationAsRead')(select({
    items: function () { return mailStore.items; },
})(function autoMarkConversationAsRead(conversationId, tableView, state) {
    // the tableRelations for all the rowKeys for a given rowId would be same hence
    // we only work with one rowKey here.
    var rowKeys = getRowKeysFromRowIds([conversationId], tableView);
    var tableConversationRelation = getTableConversationRelation(rowKeys[0], tableView.id);
    // tableConversationRelation can be null because this is an async callback, and
    // the conversation could have been deleted by the time onMarkAsReadTimeout is called
    if (!tableConversationRelation) {
        return;
    }
    if (getViewFilterForTable(tableView) == 'Unread') {
        // Auto mark as read is not supported in Unread view filter
        return;
    }
    var allItemIdsInConversation = tableConversationRelation.itemIds;
    // Do thing if all the items inside the conversation are suppressed, which means there is nothing to be marked as read.
    // Here we check if allItemIdsInConversation is a subset of suppressedItemIds instead of equal, because they
    // could be out of sync, e.g. rowNotification removed an item but its id is still in suppressed map
    if (suppressedItemIdsMapOperations.contains(allItemIdsInConversation)) {
        return;
    }
    // Mark the whole converation as read if there's nothing to suppress
    if (suppressedItemIdsMapOperations.isEmpty()) {
        markConversationsAsReadBasedOnConversationIds([conversationId], tableView, true /* isReadValue */, false /* isExplicit */, 'NonUserAction' /* actionSource */, [] /* instrumentationContexts */);
    }
    else {
        // Otherwise, mark each item as read if they are loaded in item cache, and skip the items in suppressed map
        // VSO 12718: batch itemIds for markItemReadUnread action
        allItemIdsInConversation.forEach(function (id) {
            if (!suppressedItemIdsMapOperations.contains([id]) && state.items.get(id)) {
                markItemsAsReadBasedOnItemIds(tableView, [id], true /* isReadValueToSet */, false /* isExplicit */, 'NonUserAction' /* actionSource */, [] /* instrumentationContexts */);
            }
        });
    }
    // Clear the suppressed itemIds map on navigation away
    suppressedItemIdsMapOperations.clear();
}));
//# sourceMappingURL=autoMarkConversationAsRead.js.map